import { Mapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { LinkContextProvider } from "@/components/Navigation/FlyoutMenu/components/category/components/context/link.context";
import { useCategoryContext } from "@/components/Navigation/FlyoutMenu/components/category/context/category.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Links = ({ className, children }: Props) => {
    const { category } = useCategoryContext();

    return (
        <ul className={className}>
            <Mapped
                array={category?.subCategories ?? []}
                Wrapper={LinkContextProvider}
            >
                {children}
            </Mapped>
        </ul>
    );
};
